import { useEffect } from 'react'
import { useDebounce } from 'use-debounce'

type TDebouncedConfig<V> = {
  /** default to 400 */
  time?: number
  onDebouncedChange?: (v?: V) => void
}

export type THookDebouncedArgs<V> = {
  withDebouncedConfig?: TDebouncedConfig<V>
}

export const useDebouncedInput = <V extends $TSFixMe>({
  withDebouncedConfig,
  value,
}: THookDebouncedArgs<V> & Pick<TInputProps<V>, 'value'>) => {
  const debounced = useDebounce(value, withDebouncedConfig?.time || 400)

  useEffect(() => {
    withDebouncedConfig?.onDebouncedChange?.(debounced[0])
  }, [debounced, withDebouncedConfig])
}
